
import React from 'react';
import { DialerLayout } from '@/components/dialer/layout/DialerLayout';
import { ErrorBoundary } from '@/components/ErrorBoundary';

const Dialer = () => {
  console.log('🔍 Dialer page component rendering');
  
  return (
    <ErrorBoundary>
      <DialerLayout />
    </ErrorBoundary>
  );
};

export default Dialer;
